import Vue from "vue";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import pageJson from "../../data/pages.json";

import { Howl, Howler } from "howler";

export default {
  state: () => ({
    denied: null,
    aftermath: null,
    confirm: null,
    countdown: null,
    difficulty: null,
    names: null,
    pledge: null,
    questionnaire: null,
    roles: null,
    scenario: null,
    sides: null,
    strategy: null,
    task: null,
    timer: null,
    welcome: null,
    silence: null,
  }),

  mutations: {
    SET_AUDIO(state, payload) {
      Vue.set(state, payload.key, payload.audio);
    },
  },

  actions: {
    initHowler: ({ state, commit }) => {
      // Connect to cloud storage
      var storage = firebase.storage();

      // Load a url from the cloud server
      storage
        .ref("Access_Denied.mp3")
        .getDownloadURL()
        .then((url) => {
          // Add to state
          commit("SET_AUDIO", {
            key: "denied",
            audio: new Howl({
              src: [url],
              preload: true,
            }),
          });
        });

      storage
        .ref("silence.mp3")
        .getDownloadURL()
        .then((url) => {
          // Add to state
          commit("SET_AUDIO", {
            key: "silence",
            audio: new Howl({
              src: [url],
              preload: true,
              autoplay: true,
            }),
          });
        });

      storage
        .ref("countdown.mp3")
        .getDownloadURL()
        .then((url) => {
          // Add to state
          commit("SET_AUDIO", {
            key: "countdown",
            audio: new Howl({
              src: [url],
              preload: false,
            }),
          });
        });

      // Create all the Howler instances
      for (let i = 0; i < pageJson.length; i++) {
        // Check if there's a sound
        if (
          pageJson[i].hasOwnProperty("sound") &&
          state.hasOwnProperty(pageJson[i].name)
        ) {
          // Load a url from the cloud server
          storage
            .ref(pageJson[i].sound)
            .getDownloadURL()
            .then((url) => {
              // Add to state
              commit("SET_AUDIO", {
                key: pageJson[i].name,
                audio: new Howl({
                  src: [url],
                  // Preload timer audio so it loads immediately
                  preload: pageJson[i].name == "timer" ? true : false,
                }),
              });
            });
        }
      }
    },

    preloadHowler: ({ state }, key) => {
      // check that the key is valid (we can send anything and some pages dont have corresponding audio files)
      if (state.hasOwnProperty(key) && state[key]) {
        // Check if the sound is loaded
        if (state[key].state() == "unloaded") {
          state[key].load();
        }
      }
    },

    playHowler: ({ state }, key) => {
      // console.log('playHowler', key, state[key].state(), state[key]);

      // check that the key is valid (we can send anything and some pages dont have corresponding audio files)
      if (state.hasOwnProperty(key) && state[key]) {
        // Check if the sound is loaded
        if (state[key].state() == "unloaded") {
          state[key].load();
          state[key].once("load", () => {
            // Play the sound
            state[key].play();
          });
        } else {
          // Play the sound
          state[key].play();
        }
      }
    },

    stopHowler: ({ state }, key) => {
      if (state[key] != null && state[key].playing()) {
        // Remove the load listeners so we don't accidentally still play the audio after it loads
        state[key].off("load");
        state[key].stop();
      }
    },

    stopAllHowler: () => {
      // Use global Howler instance to stop ALL sounds and return to start position
      Howler.stop();
    },
  },
};
